import { createSelector } from '@reduxjs/toolkit'

import { ManychatLegalEntity } from 'common/billing/constants/AccountBillingInfo'
import { getManychatLegalEntity } from 'common/billing/entities/billingInfo/selectors'
import { getRootBillingState } from 'common/billing/entities/miscellaneous/selectors'
import { getCurrentAccount, getIsPro } from 'common/core/selectors/appSelectors'

export const getAccountTaxNumber = createSelector(
  [getCurrentAccount],
  (account) => account.billing_info?.tax_number,
)

export const getShouldRequestTaxNumber = createSelector(
  [getManychatLegalEntity, getIsPro, (state: RootState, force?: boolean) => force],
  (legalEntity, isPro, force = false) =>
    legalEntity === ManychatLegalEntity.Brazil && (!isPro || force),
)

export const getTaxFormShown = createSelector(
  getRootBillingState,
  (billing) => billing.taxForm.isOpen,
)
